<template>
  <div class="sm-notification-top">
    <div class="sm-wrap">
      <div 
        class="sm-notification-top__email"
        @click="editEmail"
      >
        <span class="sm-notification__inner">
          <include-svg :name="'icon-warning'" />
          <span><b class="sm-txt-strong">It seems this user has an invalid email address.</b> Please update it so that the user continues receiving SphereMail emails.</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'email-notification',
  methods: {
    editEmail() {
      this.$router.push({query: {edit: 'email'}});
    }
  }
}
</script>